/* ==========================================================================
   TEENWEAR — cart drawer extras
   kupon · addon · terms gate · zbalitelna sekcia odporucani ·
   quick add + popup s vyberom variantu · translucentna paticka ·
   vlastna obsluha mnozstva a mazania polozky (kvoli zlavam)
   ========================================================================== */
(function () {
  'use strict';

  var RECENT_KEY = 'tw_recent';
  var RECENT_MAX = 12;
  var ADDON_DECLINED = 'tw_addon_declined';
  var RECS_COLLAPSED = 'tw_recs_collapsed';
  var addonAutoTried = false;
  var addonCleanupBusy = false;
  var lineBusy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function isSK() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('sk') === 0;
  }

  function getCart() {
    return fetch(root() + 'cart.js?t=' + Date.now(), {
      credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function postJSON(path, body) {
    return fetch(root() + path, {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function readResponse(res) {
    return res.text().then(function (txt) {
      var data = null;
      try { data = JSON.parse(txt); } catch (e) {}
      return { ok: res.ok, status: res.status, data: data };
    });
  }

  function refreshCart() {
    var onCartPage = window.MinimogSettings && window.MinimogSettings.templateName === 'cart';
    if (onCartPage) { window.location.reload(); return; }
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
    else window.location.reload();
  }

  function addonId() {
    var box = document.querySelector('[data-tw-addon]');
    return box ? parseInt(box.getAttribute('data-variant-id'), 10) || 0 : 0;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------- VYSKA PATICKY (blur) */
  function measureFooter() {
    var foot = document.querySelector('.tw-drawer__foot');
    var inner = document.querySelector('.tw-drawer__inner');
    if (!foot || !inner) return;
    inner.style.setProperty('--tw-foot-h', foot.offsetHeight + 'px');
  }

  function watchFooter() {
    var foot = document.querySelector('.tw-drawer__foot');
    if (!foot) return;
    measureFooter();
    if (window.ResizeObserver) new ResizeObserver(measureFooter).observe(foot);
    window.addEventListener('resize', measureFooter);
  }

  /* ------------------------------------------- ZBALITELNA SEKCIA ODPORUCANI */
  function recsCollapsed() {
    try { return window.sessionStorage.getItem(RECS_COLLAPSED) === '1'; }
    catch (e) { return false; }
  }
  function setRecsCollapsed(v) {
    try {
      if (v) window.sessionStorage.setItem(RECS_COLLAPSED, '1');
      else window.sessionStorage.removeItem(RECS_COLLAPSED);
    } catch (e) {}
  }

  function applyRecsState() {
    var box = document.querySelector('[data-tw-recs]');
    if (!box) return;
    var open = !recsCollapsed();
    box.classList.toggle('is-open', open);
    var head = box.querySelector('[data-tw-recs-toggle]');
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggleRecs(box) {
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    var head = box.querySelector('[data-tw-recs-toggle]');
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    setRecsCollapsed(!open);
    measureFooter();
  }

  /* ------------------------------------------------------------ KUPON UI */
  function findDiscountBox(el) {
    var inside = el.closest('[data-tw-discount]');
    if (inside) return inside;
    var scope = el.closest('.tw-drawer__inner') || document;
    return scope.querySelector('[data-tw-discount]');
  }

  function appliedCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) {
      if (!d || !d.code) return false;
      if (d.applied === false) return false;
      if (d.applicable === false) return false;
      return true;
    });
  }
  function codeList(cart) {
    return appliedCodes(cart).map(function (d) { return String(d.code); });
  }
  function findCodeEntry(cart, code) {
    var target = String(code).toUpperCase();
    return (cart.discount_codes || []).filter(function (d) {
      return d && (d.code || '').toUpperCase() === target;
    })[0] || null;
  }

  function showMsg(form, text) {
    var msg = form.querySelector('[data-tw-discount-msg]');
    if (!msg) return;
    msg.textContent = text; msg.hidden = false; measureFooter();
  }
  function clearMsg(form) {
    var msg = form.querySelector('[data-tw-discount-msg]');
    if (!msg) return;
    msg.textContent = ''; msg.hidden = true;
  }

  function renderCodes(cart) {
    var codes = appliedCodes(cart);

    document.querySelectorAll('[data-tw-code-count]').forEach(function (b) {
      b.textContent = codes.length;
      b.hidden = codes.length === 0;
    });

    var list = document.querySelector('[data-tw-code-list]');
    if (!list) return;
    var box = list.closest('[data-tw-discount]');
    var removeLabel = (box && box.getAttribute('data-remove-text')) || 'Remove';

    if (!codes.length) { list.innerHTML = ''; list.hidden = true; return; }

    list.innerHTML = codes.map(function (d) {
      var code = esc(d.code);
      return '<li class="tw-code"><span>' + code + '</span>' +
        '<button type="button" class="tw-code__x" data-tw-code-remove="' + code + '" ' +
        'aria-label="' + esc(removeLabel) + ' ' + code + '">' +
        '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
        '<path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '</svg></button></li>';
    }).join('');
    list.hidden = false;
  }

  function cleanupOrphanAddon(cart) {
    var id = addonId();
    if (!id || addonCleanupBusy) return false;

    var items = cart.items || [];
    var hasReal = items.some(function (i) { return i.variant_id !== id; });
    var hasAddon = items.some(function (i) { return i.variant_id === id; });
    if (hasReal || !hasAddon) return false;

    addonCleanupBusy = true;
    postJSON('cart/change.js', { id: String(id), quantity: 0 })
      .then(readResponse)
      .then(function () { refreshCart(); })
      .catch(function () {})
      .finally(function () { addonCleanupBusy = false; });
    return true;
  }

  function syncCart() {
    getCart()
      .then(function (cart) {
        if (cleanupOrphanAddon(cart)) return;

        var id = addonId();
        var count = 0;
        (cart.items || []).forEach(function (i) {
          if (i.variant_id !== id) count += i.quantity;
        });

        document.querySelectorAll('[data-tw-cart-count]').forEach(function (el) {
          el.textContent = count;
        });

        var drawer = document.querySelector('m-cart-drawer.tw-drawer');
        if (drawer) drawer.classList.toggle('m-cart--empty', count === 0);
        if (count === 0) addonAutoTried = false;

        renderCodes(cart);
        applyRecsState();
        measureFooter();
      })
      .catch(function () {});
  }

  /* ==========================================================================
     ZMENA MNOZSTVA A MAZANIE POLOZKY
     Obsluhujeme si to sami (capture faza + stopPropagation), lebo:
       1. Minimogov stepper v draweri nespolahlivo znizoval mnozstvo
       2. Shopify odmietne /cart/change.js, ak by po zmene prestal platit
          uplatneny zlavovy kod (minimalna suma objednavky) — kody preto
          odlozime, zmenu vykoname a hned ich skusime nasadit spat
     ====================================================================== */
  function isDiscountBlock(res) {
    if (!res || res.ok) return false;
    var txt = JSON.stringify(res.data || '').toLowerCase();
    return res.status === 422 || txt.indexOf('discount') !== -1;
  }

  function changeLine(line, qty, el) {
    if (lineBusy) return Promise.resolve();
    lineBusy = true;
    if (el) { el.style.opacity = '.4'; el.style.pointerEvents = 'none'; }
    var saved = [];

    return getCart()
      .then(function (cart) {
        saved = codeList(cart);
        return postJSON('cart/change.js', { line: line, quantity: qty }).then(readResponse);
      })
      .then(function (res) {
        if (!isDiscountBlock(res)) return null;
        return postJSON('cart/update.js', { discount: '' })
          .then(function () {
            return postJSON('cart/change.js', { line: line, quantity: qty }).then(readResponse);
          })
          .then(function () {
            if (!saved.length) return null;
            return postJSON('cart/update.js', { discount: saved.join(',') }).then(readResponse);
          });
      })
      .then(function () { refreshCart(); syncCart(); })
      .catch(function () {})
      .finally(function () {
        lineBusy = false;
        if (el) { el.style.opacity = ''; el.style.pointerEvents = ''; }
      });
  }

  /* ------------------------------------------------------ UPLATNENIE KODU */
  function applyDiscount(form) {
    var input = form.querySelector('[data-tw-discount-input]');
    var code = ((input && input.value) || '').trim();
    if (!code) return;

    var txt = {
      generic: form.getAttribute('data-error-text') || 'Invalid code',
      unknown: form.getAttribute('data-error-unknown') || form.getAttribute('data-error-text'),
      scope: form.getAttribute('data-error-scope') || form.getAttribute('data-error-text'),
      empty: form.getAttribute('data-error-empty') || form.getAttribute('data-error-text')
    };

    clearMsg(form);
    form.classList.add('is-loading');

    getCart()
      .then(function (cart) {
        if (!(cart.items || []).length) { showMsg(form, txt.empty); return null; }
        var keep = codeList(cart).filter(function (c) {
          return c.toUpperCase() !== code.toUpperCase();
        });
        return postJSON('cart/update.js', { discount: keep.concat(code).join(',') })
          .then(readResponse);
      })
      .then(function (res) {
        if (!res) return null;
        if (!res.ok) {
          var m = res.data && (res.data.description || res.data.message);
          showMsg(form, m || txt.unknown);
          return null;
        }
        return getCart().then(function (cart) {
          renderCodes(cart);
          var entry = findCodeEntry(cart, code);
          var applied = entry && entry.applicable !== false && entry.applied !== false;
          if (applied) {
            if (input) input.value = '';
            clearMsg(form);
            closeDiscount(form);
            refreshCart();
            return;
          }
          showMsg(form, entry ? txt.scope : txt.unknown);
        });
      })
      .catch(function () { showMsg(form, txt.generic); })
      .finally(function () {
        form.classList.remove('is-loading');
        measureFooter();
      });
  }

  function removeDiscount(box, code) {
    box.classList.add('is-loading');
    var target = String(code || '').toUpperCase();

    getCart()
      .then(function (cart) {
        var keep = codeList(cart).filter(function (c) { return c.toUpperCase() !== target; });
        return postJSON('cart/update.js', { discount: keep.join(',') });
      })
      .then(function () { return getCart(); })
      .then(function (cart) {
        var still = codeList(cart).some(function (c) { return c.toUpperCase() === target; });
        if (!still) { renderCodes(cart); refreshCart(); return null; }
        return fetch('/discount/TWCLEAR' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
          .then(function () { return getCart(); })
          .then(function (c2) { renderCodes(c2); refreshCart(); });
      })
      .catch(function () {})
      .finally(function () {
        box.classList.remove('is-loading');
        measureFooter();
      });
  }

  function openDiscount(box, on) {
    box.classList.toggle('is-open', on);
    var scope = box.closest('.tw-drawer__inner') || document;
    var btn = scope.querySelector('[data-tw-discount-toggle]');
    if (btn) btn.classList.toggle('is-open', on);
  }
  function closeDiscount(box) { openDiscount(box, false); }

  /* ------------------------------------------------------ ADDON (doplnok) */
  function addonDeclined() {
    try { return window.sessionStorage.getItem(ADDON_DECLINED) === '1'; }
    catch (e) { return false; }
  }
  function setAddonDeclined(v) {
    try {
      if (v) window.sessionStorage.setItem(ADDON_DECLINED, '1');
      else window.sessionStorage.removeItem(ADDON_DECLINED);
    } catch (e) {}
  }

  function setAddon(box, on, silent) {
    var id = parseInt(box.getAttribute('data-variant-id'), 10);
    if (!id) return;
    box.classList.add('is-loading');

    var req = on
      ? postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      : postJSON('cart/change.js', { id: String(id), quantity: 0 });

    req.then(readResponse)
      .then(function () {
        box.classList.toggle('is-on', on);
        if (!silent) refreshCart();
      })
      .catch(function () {
        var input = box.querySelector('[data-tw-addon-switch]');
        if (input) input.checked = !on;
      })
      .finally(function () {
        box.classList.remove('is-loading');
        measureFooter();
      });
  }

  function maybeAutoAddon() {
    var box = document.querySelector('[data-tw-addon]');
    if (!box || box.getAttribute('data-tw-addon-auto') !== 'true') return;
    if (addonAutoTried || addonDeclined()) return;

    var id = parseInt(box.getAttribute('data-variant-id'), 10);
    if (!id) return;

    getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var hasReal = items.some(function (i) { return i.variant_id !== id; });
        var hasAddon = items.some(function (i) { return i.variant_id === id; });
        if (!hasReal || hasAddon) return;

        addonAutoTried = true;
        var input = box.querySelector('[data-tw-addon-switch]');
        if (input) input.checked = true;
        setAddon(box, true);
      })
      .catch(function () {});
  }

  /* ------------------------------------------------- RECENTLY VIEWED STORE */
  function getRecent() {
    try {
      var v = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function trackRecent() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var id = meta && meta.product && meta.product.id;
    if (!id) return;
    var list = getRecent().filter(function (x) { return x !== id; });
    list.unshift(id);
    try {
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) {}
  }

  /* ========================================== POPUP S VYBEROM VARIANTU == */
  var vm = { el: null, data: null, sel: [], card: null };

  function ensureModal() {
    if (vm.el) return vm.el;
    var el = document.createElement('div');
    el.className = 'tw-vmodal';
    el.innerHTML =
      '<div class="tw-vmodal__bg" data-tw-vclose></div>' +
      '<div class="tw-vmodal__card" role="dialog" aria-modal="true">' +
        '<button type="button" class="tw-vmodal__close" data-tw-vclose aria-label="Close">' +
          '<svg viewBox="0 0 12 12" fill="none"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="tw-vmodal__head">' +
          '<img class="tw-vmodal__img" alt="" data-tw-vimg>' +
          '<div><p class="tw-vmodal__name" data-tw-vname></p>' +
          '<span class="tw-vmodal__price" data-tw-vprice></span></div>' +
        '</div>' +
        '<div data-tw-vopts></div>' +
        '<button type="button" class="tw-vmodal__btn" data-tw-vadd disabled></button>' +
        '<a class="tw-vmodal__link" data-tw-vlink></a>' +
      '</div>';
    document.body.appendChild(el);
    vm.el = el;
    return el;
  }

  function optionValues(idx) {
    var seen = [];
    vm.data.variants.forEach(function (v) {
      if (seen.indexOf(v.options[idx]) === -1) seen.push(v.options[idx]);
    });
    return seen;
  }

  function valueAvailable(idx, value) {
    return vm.data.variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[idx] !== value) return false;
      for (var i = 0; i < vm.sel.length; i++) {
        if (i === idx) continue;
        if (vm.sel[i] && v.options[i] !== vm.sel[i]) return false;
      }
      return true;
    });
  }

  function matchingVariants() {
    return vm.data.variants.filter(function (v) {
      return vm.sel.every(function (s, i) { return !s || v.options[i] === s; });
    });
  }

  function currentVariant() {
    if (vm.sel.some(function (s) { return !s; })) return null;
    return matchingVariants()[0] || null;
  }

  function valueImage(idx, value) {
    var m = vm.data.variants.filter(function (v) {
      return v.options[idx] === value && v.image;
    })[0];
    return m ? m.image : null;
  }

  function renderModal() {
    var el = vm.el;
    var opts = el.querySelector('[data-tw-vopts]');

    opts.innerHTML = vm.data.options.map(function (name, idx) {
      var values = optionValues(idx);

      var images = values.map(function (val) { return valueImage(idx, val); });
      var distinct = [];
      images.forEach(function (im) {
        if (im && distinct.indexOf(im) === -1) distinct.push(im);
      });
      var useImg = images.every(function (im) { return !!im; }) && distinct.length > 1;

      var chips = values.map(function (val, i) {
        var ok = valueAvailable(idx, val);
        var sel = vm.sel[idx] === val ? ' is-sel' : '';
        var attrs = (ok ? '' : ' disabled') +
          ' data-tw-vval="' + idx + '" data-tw-vvalue="' + esc(val) + '"' +
          ' title="' + esc(val) + '"';

        if (useImg) {
          return '<button type="button" class="tw-vval tw-vval--img' + sel + '"' + attrs +
            ' aria-label="' + esc(val) + '">' +
            '<img src="' + esc(images[i]) + '" alt="' + esc(val) + '" loading="lazy"></button>';
        }
        return '<button type="button" class="tw-vval' + sel + '"' + attrs + '>' +
          esc(val) + '</button>';
      }).join('');

      var head = esc(name);
      if (vm.sel[idx]) {
        head += ' <span class="tw-vopt__sel">' + esc(vm.sel[idx]) + '</span>';
      }

      return '<div class="tw-vopt"><p class="tw-vopt__name">' + head + '</p>' +
        '<div class="tw-vopt__vals">' + chips + '</div></div>';
    }).join('');

    var matches = matchingVariants();
    var exact = currentVariant();

    var withImg = matches.filter(function (v) { return v.image && v.available; })[0]
      || matches.filter(function (v) { return v.image; })[0];
    var src = (withImg && withImg.image) || vm.data.image || '';
    var imgEl = el.querySelector('[data-tw-vimg]');
    if (src && imgEl.getAttribute('src') !== src) imgEl.setAttribute('src', src);

    el.querySelector('[data-tw-vprice]').textContent =
      (exact && exact.price) || (matches[0] && matches[0].price) || vm.data.variants[0].price;

    var addBtn = el.querySelector('[data-tw-vadd]');
    addBtn.disabled = !exact || !exact.available;
    addBtn.textContent = vm.data.addLabel;
    addBtn.setAttribute('data-variant-id', exact ? exact.id : '');
  }

  function openModal(card) {
    var holder = card.querySelector('script[data-tw-product]');
    if (!holder) return;

    var data;
    try { data = JSON.parse(holder.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;

    ensureModal();
    vm.data = data;
    vm.card = card;
    vm.sel = data.options.map(function () { return null; });

    data.options.forEach(function (name, idx) {
      var seen = [];
      data.variants.forEach(function (v) {
        if (seen.indexOf(v.options[idx]) === -1) seen.push(v.options[idx]);
      });
      if (seen.length === 1) vm.sel[idx] = seen[0];
    });

    vm.data.addLabel = isSK() ? 'Pridať do košíka' : 'Add to bag';

    var el = vm.el;
    el.querySelector('[data-tw-vname]').textContent = data.title;
    var link = el.querySelector('[data-tw-vlink]');
    link.href = data.url;
    link.textContent = isSK() ? 'Zobraziť produkt' : 'View product';

    renderModal();
    el.classList.add('is-open');
  }

  function closeModal() {
    if (vm.el) vm.el.classList.remove('is-open');
  }

  /* ------------------------------------------------------------ QUICK ADD */
  function quickAdd(btn, fromModal) {
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;

    var card = fromModal ? vm.card : btn.closest('.tw-rec');
    var plus = card ? card.querySelector('.tw-rec__add') : null;

    btn.classList.add('is-loading');
    btn.style.pointerEvents = 'none';

    postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(readResponse)
      .then(function (res) {
        if (!res.ok) return;
        closeModal();
        if (plus) {
          plus.classList.add('is-added');
          setTimeout(function () { plus.classList.remove('is-added'); }, 1500);
        }
        refreshCart();
        syncCart();
      })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.style.pointerEvents = '';
      });
  }

  /* ============================================================== INIT ==
     Mnozstvo aj mazanie preberame od Minimogu v capture faze — LEN v draweri. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* mazanie polozky */
    var rm = e.target.closest('m-cart-remove-button');
    if (rm && rm.closest('.tw-drawer')) {
      e.preventDefault();
      e.stopPropagation();
      var rmLine = parseInt(rm.getAttribute('data-index'), 10);
      if (rmLine) changeLine(rmLine, 0, rm);
      return;
    }

    /* plus / minus pri mnozstve */
    var qbtn = e.target.closest('.tw-qty .m-quantity__button');
    if (qbtn && qbtn.closest('.tw-drawer')) {
      e.preventDefault();
      e.stopPropagation();

      var wrap = qbtn.closest('m-quantity-input');
      var field = wrap && wrap.querySelector('.m-quantity__input');
      if (!field) return;

      var qLine = parseInt(field.getAttribute('data-index'), 10);
      var cur = parseInt(field.value, 10);
      if (isNaN(cur)) cur = 1;

      var next = qbtn.getAttribute('name') === 'plus' ? cur + 1 : cur - 1;

      /* pod 1 nejdeme — na odstranenie je kos */
      if (next < 1) return;

      var maxAttr = parseInt(field.getAttribute('max'), 10);
      if (!isNaN(maxAttr) && next > maxAttr) return;

      field.value = next;
      if (qLine) changeLine(qLine, next, wrap);
      return;
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-tw-vclose]')) { closeModal(); return; }

    var vval = e.target.closest('[data-tw-vval]');
    if (vval && !vval.disabled) {
      e.preventDefault();
      var idx = parseInt(vval.getAttribute('data-tw-vval'), 10);
      var val = vval.getAttribute('data-tw-vvalue');
      vm.sel[idx] = (vm.sel[idx] === val) ? null : val;
      renderModal();
      return;
    }

    var vadd = e.target.closest('[data-tw-vadd]');
    if (vadd && !vadd.disabled) { e.preventDefault(); quickAdd(vadd, true); return; }

    var recsToggle = e.target.closest('[data-tw-recs-toggle]');
    if (recsToggle) {
      e.preventDefault();
      var recsBox = recsToggle.closest('[data-tw-recs]');
      if (recsBox) toggleRecs(recsBox);
      return;
    }

    var varToggle = e.target.closest('[data-tw-var-toggle]');
    if (varToggle) {
      e.preventDefault();
      var pickCard = varToggle.closest('.tw-rec');
      if (pickCard) openModal(pickCard);
      return;
    }

    var addBtn = e.target.closest('[data-tw-quick-add]');
    if (addBtn) { e.preventDefault(); quickAdd(addBtn); return; }

    /* klik kdekolvek inde na karte — otvara popup, nie produktovku */
    var recCard = e.target.closest('[data-tw-rec]');
    if (recCard && recCard.querySelector('script[data-tw-product]')) {
      e.preventDefault();
      openModal(recCard);
      return;
    }

    var removeBtn = e.target.closest('[data-tw-code-remove]');
    if (removeBtn) {
      e.preventDefault();
      var rbox = removeBtn.closest('[data-tw-discount]');
      if (rbox) removeDiscount(rbox, removeBtn.getAttribute('data-tw-code-remove'));
      return;
    }

    var toggle = e.target.closest('[data-tw-discount-toggle]');
    if (toggle) {
      e.preventDefault();
      var box = findDiscountBox(toggle);
      if (box) {
        var willOpen = !box.classList.contains('is-open');
        openDiscount(box, willOpen);
        var fld = box.querySelector('[data-tw-discount-input]');
        if (willOpen && fld) fld.focus();
      }
      return;
    }

    var applyBtn = e.target.closest('[data-tw-discount-apply]');
    if (applyBtn) {
      e.preventDefault();
      var form = applyBtn.closest('[data-tw-discount]');
      if (form) applyDiscount(form);
      return;
    }

    var addonMore = e.target.closest('[data-tw-addon-more]');
    if (addonMore) {
      e.preventDefault();
      var addonBox = addonMore.closest('[data-tw-addon]');
      if (addonBox) { addonBox.classList.toggle('is-open'); measureFooter(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Enter' || !e.target.closest) return;
    var input = e.target.closest('[data-tw-discount-input]');
    if (!input) return;
    e.preventDefault();
    var form = input.closest('[data-tw-discount]');
    if (form) applyDiscount(form);
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    /* rucne prepisanie mnozstva v poli */
    if (el.classList && el.classList.contains('m-quantity__input') && el.closest('.tw-drawer')) {
      e.preventDefault();
      e.stopPropagation();
      var n = parseInt(el.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      el.value = n;
      var ln = parseInt(el.getAttribute('data-index'), 10);
      if (ln) changeLine(ln, n, el.closest('m-quantity-input'));
      return;
    }

    if (el.type !== 'checkbox') return;

    if (el.hasAttribute('data-tw-addon-switch')) {
      var addonBox = el.closest('[data-tw-addon]');
      if (!addonBox) return;
      setAddonDeclined(!el.checked);
      setAddon(addonBox, el.checked);
      return;
    }

    var wrap2 = el.closest('[data-tw-terms]');
    if (!wrap2) return;
    var scope = wrap2.closest('[data-tw-checkout-scope]') || document;
    scope.querySelectorAll('[data-tw-checkout]').forEach(function (b) {
      b.disabled = !el.checked;
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    watchFooter();
    applyRecsState();
    syncCart();

    if (!window.MinimogEvents || !window.MinimogTheme) return;
    var ev = window.MinimogTheme.pubSubEvents || {};

    if (ev.cartUpdate) window.MinimogEvents.subscribe(ev.cartUpdate, syncCart);
    if (ev.openCartDrawer) {
      window.MinimogEvents.subscribe(ev.openCartDrawer, function () {
        syncCart();
        maybeAutoAddon();
      });
    }
  });

  window.addEventListener('load', function () {
    trackRecent();
    measureFooter();
  });
})();
